import React from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { EMarkingTypes } from 'constants/Markings';
import {
  EAdditionalFields,
  EMarkingsLabels,
  RenderAdditionalField,
  RenderMarking,
} from './helpers';
import { ETransactionTypes } from 'constants/TransactionTypes';

interface IDataSource {
  [key: string]: any;
}

interface ITransactionDetailsMarkingsCard {
  data: IDataSource;
  fieldsForTransactionType: (EMarkingTypes | EAdditionalFields)[];
  transactionType?: ETransactionTypes;
}
const DetailsMarkingsItem = ({
  data,
  fieldsForTransactionType,
  transactionType,
}: ITransactionDetailsMarkingsCard) => {
  const { t } = useTranslations();

  return (
    <>
      <RenderMarking
        markings={data.markings}
        label={EMarkingsLabels.importMarking}
        type={EMarkingTypes.IMPORT}
        addedLabel={data.length > 1}
        emptyString={
          data.wasAssetImported ||
            (transactionType && transactionType !== ETransactionTypes.MARKED)
            ? '-'
            : t(EMarkingsLabels.notApplicable)
        }
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />
      <RenderMarking
        markings={data.markings}
        label={EMarkingsLabels.appliedMarking}
        type={EMarkingTypes.APPLIED}
        addedLabel={data.length > 1}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />

      <RenderMarking
        markings={data.markings}
        label={EMarkingsLabels.confiscationMarking}
        type={EMarkingTypes.CONFISCATION}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />
      <RenderAdditionalField
        label={EMarkingsLabels.yearOfConfiscation}
        value={data.yearOfConfiscation}
        type={EAdditionalFields.YEAR_OF_CONFISCATION}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />

      <RenderMarking
        markings={data.markings}
        label={EMarkingsLabels.surplusSaleMarking}
        type={EMarkingTypes.SURPLUS_SALE}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />
      <RenderAdditionalField
        label={EMarkingsLabels.yearOfTransfer}
        value={data.yearOfTransfer}
        type={EAdditionalFields.YEAR_OF_TRANSFER}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />

      <RenderMarking
        markings={data.markings}
        label={EMarkingsLabels.exportMarking}
        type={EMarkingTypes.EXPORT}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />

      <RenderMarking
        markings={data.markings}
        label={EMarkingsLabels.deactivationMarking}
        type={EMarkingTypes.DEACTIVATION}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />

      <RenderAdditionalField
        label={EMarkingsLabels.serialNumber}
        value={data.serialNumber}
        type={EAdditionalFields.SERIAL_NUMBER}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />
      <RenderAdditionalField
        label={EMarkingsLabels.batchNumber}
        value={data.batchNumber}
        type={EAdditionalFields.BATCH_NUMBER}
        fieldsForTransactionType={fieldsForTransactionType}
        t={t}
      />
    </>
  );
};

export { DetailsMarkingsItem };
